/**
 * @description defines base routes for the entire application
 */

import faqRoutes from './faq';
import personnelMappingRoutes from './personnelMapping';
import personnelSyncAdminRoutes from './personnelSyncAdmin';
import personnelSyncRoutes from './personnelSync';
import privacyPolicyRoutes from './privacyPolicy';
import contracts from './contracts';
import knowledgeCenterRoutes from './knowledgeCenter';
import foreignTravel from './foreignTravelReport';
import personnelComparisonTool from './personnelComparisonTool';

export default [
  ...faqRoutes,
  ...personnelMappingRoutes,
  ...personnelSyncAdminRoutes,
  ...personnelSyncRoutes,
  ...privacyPolicyRoutes,
  ...contracts,
  ...knowledgeCenterRoutes,
  ...foreignTravel,
  ...personnelComparisonTool
];
